import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import ArticleSkeleton from "src/components/NewComponents/Skeletons/Article";
import { useGetArticleByQuestionId } from "src/hooks/useArticles";
import ArticlesIcon from "src/images/Icons/newIcons/exam/options/article.svg";

import { hasLimitedAccess } from "../../../../../helpers/getPermissions";
import { useFontSize } from "../../../../../hooks/useFontSize";
import { ShortLimitedAccess } from "../../../LimitedAccess";
import DefaultOptionDetail from "../DefaultOptionDetail";
import Article from "./Article";

function Articles(props) {
	const { fontSizeClass } = useFontSize();
	const { t } = useTranslation();
	const shouldFetch = props.settings.article && !hasLimitedAccess();
	const { isLoading, data } = useGetArticleByQuestionId(
		props.question.id,
		shouldFetch,
	);

	const renderArticles = (articles) => {
		if (hasLimitedAccess()) {
			return <ShortLimitedAccess />;
		}

		return (
			<div className="flex flex-col gap-8">
				{articles.map((article) => (
					<Article key={article.id} article={article} id={article.id} />
				))}
			</div>
		);
	};

	if (!props.settings.article) {
		return null;
	}

	return (
		<DefaultOptionDetail
			dispatch={props.dispatch}
			actions={props.actions}
			isLoading={isLoading}
			data={data}
			renderContent={renderArticles}
			className={props.className}
			isOpen={props.settings.article}
			actionKey="article"
			renderHeader={() => (
				<div className="flex-center-row gap-8">
					<ArticlesIcon className="icon-normal" />
					<span className={fontSizeClass}>{t("exam.article")}</span>
				</div>
			)}
			Skeleton={<ArticleSkeleton count={2} />}
		/>
	);
}

export default styled(Articles)``;
